import { useApiMutationAdminAddNotes } from '@hooks-api/fortune-fastpass/use-api-add-admin-notes'
import { useApiMutationAdminConfirmRegularGiveaways } from '@hooks-api/fortune-fastpass/use-api-confirm-regular-giveaways'
import { PaymentMethodMap } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { GiftFilled } from '@pets-ui/icons'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom-v5'
import AdminHeader from '../../components/admin-header'
import Amount from '../../components/amount'
import FixedFooter from '../../components/fixed-footer'
import InputGroup from '../../components/input-group'
import Loading from '../../components/loading'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { useCampaign } from '../../hooks/use-campaign'
import { OrderModel } from '../../model/order-model'
import style from '../../style/pages/admin-order-check.module.scss'

const baseStyle = stylex.create({
  container: {
    padding: '32px 16px',
    borderRadius: '8px',
    gap: 12,
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    justifyContent: 'center',
    width: '100%',
  },
})

const AdminOrderCheck = () => {
  const { campaignCodeFromUrl } = useCampaign()
  const { orderId } = useParams<{ orderId?: string }>()
  const history = useHistory()
  const { t } = useTranslation()

  const [note, setNote] = useState('')
  const { destructuredData: orders } = useAdminOrders()
  const order = orders ? new OrderModel(orders) : null
  const paymentMethodInfo = orders ? PaymentMethodMap[orders?.payment_method?.type] : ''

  const adminToken = JSON.parse(sessionStorage.getItem('admin') || '{}')

  const { trigger: confirmOrder, isMutating } = useApiMutationAdminConfirmRegularGiveaways()
  const { trigger: addNotes, isMutating: isAddingNotes } = useApiMutationAdminAddNotes()

  useEffect(() => {
    if (typeof adminToken.token === 'undefined') {
      history.push(`/admin/${campaignCodeFromUrl}/admin-login`)
    }
  }, [adminToken.token, campaignCodeFromUrl, history])

  const submitOrder = async () => {
    if (!orderId) return
    await Promise.all([
      confirmOrder({
        code: campaignCodeFromUrl,
        payment_transaction_id: orderId,
      }),
      addNotes({
        code: campaignCodeFromUrl,
        payment_transaction_id: orderId,
        delivery_reason: note,
      }),
    ])
    history.push(`/admin/${campaignCodeFromUrl}/admin-checked`)
  }

  if (isMutating || isAddingNotes) {
    return <Loading />
  }

  return (
    <>
      <AdminHeader />
      <VStack gap={3} marginTop="56px" p={3}>
        <VStack rootStyle={baseStyle.container}>
          <Text variant="h1" color={colors.green400}>已付款</Text>
          <Text variant="h1">{paymentMethodInfo}</Text>
          {order
            ? (
              <>
                <Amount
                  fontSize={48}
                  bold
                  amount={parseInt(order.order.total + '')}
                />
                <HStack gap={1} alignItems="center">
                  <GiftFilled color={colors.red600} />
                  <Text color={colors.red600} bold>工作人員請確認完成滿額禮發放！</Text>
                </HStack>
              </>
            )
            : <Skeleton height={68} width={200} variant="rounded" />}

        </VStack>
        {order
          ? (
            <VStack gap={2}>
              <Text>客人訂單備註</Text>
              <Box p={2} backgroundColor={colors.grey100} borderRadius={8}>
                <Text>{order.order.customer_note || '無'}</Text>
              </Box>
            </VStack>
          )
          : <Skeleton height={24} variant="rounded" />}
        <InputGroup
          label={(
            <label htmlFor="staff-note" className={style.label}>
              {t('order.staffNotes')}
            </label>
          )}
          input={(
            <textarea
              id="staff-note"
              placeholder={t('order.staffNotePlaceholder') || ''}
              className={style.textarea}
              value={note}
              onChange={e => setNote(e.target.value)}
            />
          )}
        />
      </VStack>
      <FixedFooter>
        <Button onClick={submitOrder} fullWidth borderRadius="100px">
          確認已領取滿額禮
        </Button>
      </FixedFooter>
    </>
  )
}

export default AdminOrderCheck
